import initAdvSearch from "./adv-search";
import postRefresh from "./post-refresh";


window.onload = () => {
  initAdvSearch();
  postRefresh();

  const plainLocColor = '#7f7f7f';
  const highlightLocColor = '#8e0000';
  const uniMapColor = '#086085';
  const hawMapColor = '#83b713';

  const highlightCity = (city, color) => {
    simplemaps_countrymap.mapdata.locations.forEach(location => {
      if (location.name === city || city === 'all') {
        location.color = location.color = color;
      }
    });
    simplemaps_countrymap.refresh();
  }

  const mapdataEl = document.querySelector('#mapdata');
  const mapmodeEl = document.querySelector('#mapmode');
  let openTab = document.querySelector('.map-search .nav .nav-link.active')?.id || '';
  let mapdata = [];
  if (mapdataEl && mapmodeEl) {
    mapdata = JSON.parse(mapdataEl.getAttribute('data-mapdata'));
    const mapmode = JSON.parse(mapmodeEl.getAttribute('data-mapmode'));
    simplemaps_countrymap.hooks.click_location = id => {
      const city = mapdata[id].name;
      const button = document.querySelector('.hoverable[data-city=' + city + '] .btn-city');
      highlightCity(city, highlightLocColor);
      if (button.classList.contains('collapsed')) {
        button.click();
      }
      button.scrollIntoView({block: 'center', behavior: 'smooth'});
    }
    simplemaps_countrymap.mapdata.locations = mapdata;
    simplemaps_countrymap.mapdata.main_settings.background_color = mapmode === 1 ? uniMapColor : hawMapColor;
    simplemaps_countrymap.mapdata.main_settings.border_color = mapmode === 1 ? uniMapColor : hawMapColor;
    simplemaps_countrymap.load();
  }

  const makeLink = (span, count = 0, field, selector, andSelector, noLink = false) => {
    noLink = noLink || false;
    let text = span.getAttribute('data-text');
    text = text.replace('%d', count.toString());
    const linkText = text.split('%l')?.pop()?.split('%k')[0];
    text = text.replace(/(%l|%k)/g, '');
    let link = span.getAttribute('data-link');
    const andSearch = document.getElementById(andSelector).checked;
    const key = link.split('?').pop().split('&').shift().split('%').shift().split('%').shift();
    const del = new RegExp(key + '%5Bdel%5D=1');
    link = link.substring(0, link.indexOf('&cHash'));
    link = link.replace(del, '');
    link += '&' + key + '%5Bsearched%5D=1';
    link += '&' + key + '%5Bbesand%5D=' + (andSearch ? '1' : '0');
    document.querySelectorAll(selector).forEach(check => {
      link += '&' + key + '%5B' + field + '%5D%5B%5D=' + check.value;
    });
    if (noLink) {
      span.innerHTML = text;
    } else {
      span.innerHTML = text.replace(linkText, '<a href="' + link + '" target="_blank">' + linkText + '</a>');
    }
  }

  /** PLZ Search */
  const searchPlz = document.querySelector('#search-plz');
  if (searchPlz) {
    const counter = document.querySelector('.search-plz .plz-count');
    if (counter) {
      counter.style.display = 'none';
    }
    searchPlz.addEventListener('keyup', e => {
      if (searchPlz.value.toString().length > 5) {
        searchPlz.value = searchPlz.value.toString().substring(0, 5);
      }
      const validButtons = [];
      const validCities = new Set();
      const allPlzButtons = document.querySelectorAll('#ort-tab-pane button.uni-title');
      let validCitiesCount = 0;
      allPlzButtons.forEach(button => {
        const item = button.closest('.accordion').closest('.accordion-item');
        if (button.getAttribute('data-plz').indexOf(searchPlz.value) === 0) {
          validCitiesCount++;
          validButtons.push(button);
          validCities.add(item.getAttribute('data-city'));
        }
        item.classList.add('hidden');
      });
      // Unhide valid buttons
      validButtons.forEach(button => {
        button.closest('.accordion').closest('.accordion-item').classList.remove('hidden');
      });
      counter.style.display = 'none';
      if (validCitiesCount === 0 && counter) {
        counter.style.display = 'inline';
      }
      simplemaps_countrymap.mapdata.locations = mapdata.filter(location => validCities.has(location.name));
      simplemaps_countrymap.refresh();
    });
  }

  /** On tab change - reset map and selections */
  document.querySelectorAll('.nav .nav-link').forEach(tab => {
    tab.addEventListener('show.bs.tab', e => {
      openTab = e.target.id;
      simplemaps_countrymap.mapdata.locations = mapdata;
      document.getElementById('tt_sm_map').style.display = 'none';
      highlightCity('all', plainLocColor);
      switch (e.target.id) {
        case 'ort-tab':
          /** Reset PLZ search */
          document.getElementById('search-plz').value = '';
          const allPlzButtons = document.querySelectorAll('#ort-tab-pane button.uni-title');
          allPlzButtons.forEach(button => {
            button.closest('.accordion').closest('.accordion-item').classList.remove('hidden');
          });
          /** Reset accordions */
          const allAccordionBtns = document.querySelectorAll('#acc-ort .btn-city');
          allAccordionBtns.forEach(button => button.classList.add('collapsed'));
          const allAccordionItems = document.querySelectorAll('#acc-ort .accordion-item.hoverable > .accordion-collapse');
          allAccordionItems.forEach(item => item.classList.remove('show'));
          break;
        case 'fach-tab':
          fachMapUpdate(e);
          break;
        case 'schluessel-tab':
          schluesselMapUpdate(e);
          break;
        default:
          console.log(e.target.id);
      }
    });
  });

  /** Orte: On hover - highlight city */
  document.querySelectorAll('#acc-ort .hoverable').forEach(accordion => {
    accordion.addEventListener('mouseenter', e => {
      const city = e.target.closest('.hoverable').getAttribute('data-city');
      highlightCity(city, highlightLocColor);
    });
    accordion.addEventListener('mouseleave', e => {
      const button = e.target.querySelector('.btn-city');
      /** Only reset color if the accordion is collapsed */
      if (button.classList.contains('collapsed')) {
        const city = e.target.closest('.hoverable').getAttribute('data-city');
        highlightCity(city, plainLocColor);
      }
    });
  });

  /** Fach */
  const filterTab = (tab, filter, withChecked = false) => {
    let hadChecks = 0;
    let checkCount = 0;
    if (openTab === tab + '-tab') {
      const checks = document.querySelectorAll(filter);
      checkCount = checks.length
      const andSearch = document.getElementById('und-cb' + (tab === 'schluessel' ? '-s' : '')).checked;
      const checkedCities = new Set();
      const forschungs = new Set();
      const duplicates = new Map();
      checks.forEach(check => {
        check.closest('.accordion-item').querySelectorAll('.fs-link li').forEach(el => {
          const city = el.getAttribute('data-city');
          const forschung = el.getAttribute('data-forschung');
          if (andSearch) {
            duplicates.set(forschung, (duplicates.get(forschung) || 0) + 1);
            if (duplicates.get(forschung) === checks.length) {
              checkedCities.add(city);
              forschungs.add(forschung);
            }
          } else {
            checkedCities.add(city);
            forschungs.add(forschung);
          }
        });
      });
      hadChecks = forschungs.size;
      simplemaps_countrymap.mapdata.locations = hadChecks ? mapdata.filter(location => checkedCities.has(location.name)) : mapdata;
      simplemaps_countrymap.refresh();
    }
    if (withChecked) {
      return {
        total: hadChecks,
        checked: checkCount
      }
    }
    return hadChecks;
  }

  const fachMapUpdate = e => {
    e.stopPropagation();
    let fachCount = updateFachMapByChecks();
    if (fachCount === 0) {
      fachCount = updateFachMapByOpen();
    }
    const countSpan = document.querySelector('#fach-tab-pane .fach-count');
    if (fachCount === 0) {
      countSpan.innerHTML = '';
    } else {
      makeLink(countSpan, fachCount, 'subject', '#acc-fach .form-check-input:checked', 'und-cb');
    }
  }
  document.querySelectorAll('#acc-fach button.accordion-button').forEach(e => e.addEventListener('click', fachMapUpdate));
  document.querySelectorAll('#acc-fach input.form-check-input').forEach(e => e.addEventListener('click', fachMapUpdate));
  document.querySelectorAll('.search-und #und-cb').forEach(e => e.addEventListener('click', fachMapUpdate));
  /** If checks, show appropriate locs in map */
  const updateFachMapByChecks = () => filterTab('fach', '#acc-fach .form-check-input:checked');
  /** If open, show appropriate locs in map */
  const updateFachMapByOpen = () => filterTab('fach', '#acc-fach button.accordion-button:not(.collapsed)');

  /** Schlüsselbegriffe */
  const schluesselMapUpdate = e => {
    e.stopPropagation();
    const update = updateSchluesselMap();
    const schluesselCount = update.total;
    const checked = update.checked;
    const countSpan = document.querySelector('#schluessel-tab-pane .schluessel-count');
    if (schluesselCount === 0 && checked === 0) {
      countSpan.innerHTML = '';
    } else {
      console.log('makelink', countSpan, schluesselCount);
      makeLink(countSpan, schluesselCount, 'keyword', '#acc-schluessel .form-mini-input:checked', 'und-cb-s', schluesselCount === 0);
    }
  }
  document.querySelectorAll('#acc-schluessel input.form-mini-input').forEach(e => e.addEventListener('click', schluesselMapUpdate));
  document.querySelectorAll('.search-und  #und-cb-s').forEach(e => e.addEventListener('click', schluesselMapUpdate));
  const updateSchluesselMap = () => filterTab('schluessel', '#acc-schluessel .form-mini-input:checked', true);

  /** Schlagworte */
  const submitSearch = e => {
    e.preventDefault();
    let url = '/search.json';
    const formData = new FormData(document.querySelector('#schlag-search'));
    const lang = formData.getAll('tx_hrksearch_mapsearch[language]');
    if (lang.length === 1 && lang[0] === '1') {
      url = '/en' + url;
    }
    fetch(url, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        document.getElementById('schlag-results').innerHTML = data.data;
      }
    );
  }

  document.querySelectorAll('.btn-schlag-search').forEach(button => button.addEventListener('click', submitSearch));
}
